import { Link } from "react-router-dom";
import { MapPin, Mail, Facebook, Twitter, Linkedin, Instagram, FileText, Shield, Cookie, Gavel, Phone } from "lucide-react";
const Footer = () => {
  return <footer className="bg-fabre-gray text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Groupe Fabre Environnement</h3>
            <p className="mb-4 text-sm">
              Depuis plus de 25 ans, le Groupe Fabre développe son pôle Environnement afin de promouvoir une approche responsable de la gestion des déchets.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-white hover:text-fabre-green transition">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white hover:text-fabre-green transition">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-white hover:text-fabre-green transition">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-white hover:text-fabre-green transition">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Nos Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/professionnels" className="text-white hover:text-fabre-green transition">
                  Professionnels
                </Link>
              </li>
              <li>
                <Link to="/services/collectivites" className="text-white hover:text-fabre-green transition">
                  Collectivités
                </Link>
              </li>
              <li>
                <Link to="/services/particuliers" className="text-white hover:text-fabre-green transition">
                  Particuliers
                </Link>
              </li>
              <li>
                <Link to="/services/vehicules" className="text-white hover:text-fabre-green transition">
                  Services Véhicules
                </Link>
              </li>
              <li>
                <Link to="/valorisation" className="text-white hover:text-fabre-green transition">
                  Valorisation de Déchets
                </Link>
              </li>
            </ul>
          </div>

          {/* Pages */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Informations</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/histoire" className="text-white hover:text-fabre-green transition">
                  Notre Histoire
                </Link>
              </li>
              <li>
                <Link to="/engagements" className="text-white hover:text-fabre-green transition">
                  Nos Engagements
                </Link>
              </li>
              <li>
                <Link to="/sites" className="text-white hover:text-fabre-green transition">
                  Nos Sites
                </Link>
              </li>
              <li>
                <Link to="/valocap" className="text-white hover:text-fabre-green transition">
                  Valocap
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-fabre-green transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="mr-2 h-5 w-5 text-fabre-green flex-shrink-0 mt-0.5" />
                <span>Siège Social<br />12000 Rodez, France</span>
              </li>
              <li className="flex items-center">
                <Phone className="mr-2 h-5 w-5 text-fabre-green flex-shrink-0" />
                <a href="tel:0565678205" className="hover:text-fabre-green transition-colors">
                  05.65.67.82.05
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="mr-2 h-5 w-5 text-fabre-green flex-shrink-0" />
                <span>contactgfe@groupefabre.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-8 mb-6">
            <Link to="/mentions-legales" className="text-sm text-white hover:text-fabre-green transition flex items-center">
              <FileText className="mr-2 h-4 w-4" />
              <span>Mentions Légales</span>
            </Link>
            <Link to="/politique-confidentialite" className="text-sm text-white hover:text-fabre-green transition flex items-center">
              <Shield className="mr-2 h-4 w-4" />
              <span>Politique de Confidentialité</span>
            </Link>
            <Link to="/conditions-generales" className="text-sm text-white hover:text-fabre-green transition flex items-center">
              <Gavel className="mr-2 h-4 w-4" />
              <span>Conditions Générales</span>
            </Link>
            <Link to="/politique-cookies" className="text-sm text-white hover:text-fabre-green transition flex items-center">
              <Cookie className="mr-2 h-4 w-4" />
              <span>Politique de Cookies</span>
            </Link>
          </div>
          <p className="text-center text-sm">&copy; {new Date().getFullYear()} Groupe Fabre Environnement. Tous droits réservés.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;